import { caseAtom } from 'atoms'
import { applicationTypeAtom } from '@/atoms/globalAtoms'
import { Button } from 'components'
import { useRecoilValue } from 'recoil'
import { useTranslation } from 'react-i18next'
import { leaveForReturnUrl } from '@/utils/editor/returnToOrderUrl'
import { M3 } from '@messenger/consts'

export const OrderDashboardButton = () => {
  const { t, i18n } = useTranslation()
  const caseDetails = useRecoilValue(caseAtom)
  const applicationType = useRecoilValue(applicationTypeAtom)
  const returnUrl = caseDetails.return_url
  const isM3 = applicationType === M3
  const showReturnButton = returnUrl || isM3

  if (!showReturnButton) return null

  const handleReturnToOrder = () => {
    leaveForReturnUrl(returnUrl, i18n.language)
  }

  return (
    <Button primary onClick={handleReturnToOrder}>
      {t('editor.preview.returnToOrderButton')}
    </Button>
  )
}

export default OrderDashboardButton
